export default __webpack_public_path__ + "service-welcome.webp";